module.exports = function() {
  return new Worker(__webpack_public_path__ + "ba01c87ada503e51af7c.worker.js");
};